export default __webpack_public_path__ + "static/media/a024-startup-4.ba862455.svg";